import { shouldPolyfill } from '@formatjs/intl-pluralrules/should-polyfill'

export default async function polyfill (): Promise<void> {
  if (typeof shouldPolyfill() !== 'undefined' && shouldPolyfill() !== null) {
    // Load the polyfill 1st BEFORE loading data
    await import('@formatjs/intl-pluralrules/polyfill')
  }

  if ((Intl.PluralRules as any).polyfilled !== null) {
    await import('@formatjs/intl-pluralrules/locale-data/es')
    await import('@formatjs/intl-pluralrules/locale-data/en')
  }
}
